export enum ModuleType {
	czMaxPrice = 'cz-max-price',
	czReimbursement = 'cz-reimbursement',
	skMaxPrice = 'sk-max-price',
	roMaxPrice = 'ro-max-price',
	roMaxPriceAdditionalPriceRoof = 'ro-max-price-additional-price-roof',
}

export default class SystemModule {
	type: ModuleType;

	constructor(type: ModuleType) {
		this.type = type;
	}
}
